import m from "mithril";
const Link = m.route.Link;
export default {
    view() {
        const channel = m.route.param("channel") || null;
        return (m("article", null,
            m("div", { class: "alert alert--success alert--icon pt3 pb3" },
                m("i", { class: "fas fa-check" }),
                channel === "sms" ? (m("div", null,
                    "Du solltest in K\u00FCrze ein neues ",
                    m("strong", null, "tempor\u00E4res"),
                    " ",
                    "Passwort per SMS erhalten. Bitte \u00E4ndere es dann umgehend in ein anderes ",
                    m("strong", null, "sicheres"),
                    " Passwort.")) : (""),
                channel === "email" ? (m("div", null, "Du solltest in K\u00FCrze einen Link erhalten, der dich f\u00FCr kurze Zeit einloggt. Bitte \u00E4ndere danach auch umgehend dein Passwort.")) : (""),
                !channel ? (m("div", null,
                    "Hat geklappt - check deine Nachrichten! Und vergiss nicht, dir umgehend ein neues ",
                    m("strong", null, "sicheres"),
                    " Passwort zu setzen.")) : ("")),
            m("div", { class: "tr" },
                m(Link, { href: "/", class: "btn btn--link", title: "zur\u00FCck zur Anmeldung" },
                    m("i", { class: "fas fa-arrow-left mr1" }),
                    " Zur\u00FCck"))));
    },
};
